var map = {
	"./ibd_arm1.png": 140,
	"./ibd_arm2.png": 141,
	"./ibd_back1.png": 142,
	"./ibd_back2.png": 143,
	"./ibd_foot1.png": 144,
	"./ibd_foot2.png": 145,
	"./ibd_hips1.png": 146,
	"./ibd_hips2.png": 147,
	"./ibd_neck1.png": 148,
	"./ibd_neck2.png": 149,
	"./ibd_shoulder1.png": 150,
	"./ibd_shoulder2.png": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;